const { createContext } = require("react");

export const myContext = createContext("");